var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBookOpen = function SvgBookOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.998v12.614M5.997 8.499H9M5.997 12H9M5.997 15.502H9M15.001 8.499h3.002M15.001 12h3.002M15.001 15.502h3.002",
    stroke: "#170426",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 21.004a3.618 3.618 0 00-3.241-2.001H4.496a1.5 1.5 0 01-1.5-1.5V5.497a1.5 1.5 0 011.5-1.5H8a4.001 4.001 0 014.001 4 4.001 4.001 0 014.001-4h3.503a1.5 1.5 0 011.5 1.5v12.006a1.5 1.5 0 01-1.497 1.5h-4.266a3.618 3.618 0 00-3.241 2z",
    stroke: "#170426",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBookOpen;